export { default as PhotoEditIcon } from "./photo-edit-icon";
export { default as EditIcon } from "./edit-icon";
export { default as SoundIcon } from "./sound-icon";
export { default as HapticIcon } from "./haptic-icon";
export { default as MinusIcon } from "./minus-icon";
export { default as PlusIcon } from "./plus-icon";
export { default as ChildsPasswordIcon } from "./childs-icon";
export { default as ParentsPasswordIcon } from "./parents-icon";
